import Vue from 'vue'
import Address from "../models/Address";
import DeliveryContact from "../models/DeliveryContact";
import RoutePlan from "../models/RoutePlan"
import Contact from "../models/Contact"

export const routePlanStore = {
    state: Vue.observable({
        admin: false,
        packageAddresses: [],
        deliveryContacts: [],
        routePlans: [],
        contacts: [],
    }),

    async init(admin = false) {
        this.state.admin = admin
        await Promise.all([
            this.fetchPackageAddresses(),
            this.fetchDeliveryContacts(),
            this.fetchRoutePlans(),
            this.fetchContacts(),
        ])
    },

    async fetchPackageAddresses() {
        if (this.state.packageAddresses.length === 0) {
            this.state.packageAddresses = await Address.packageAddresses()
        }
    },

    async fetchDeliveryContacts() {
        if (this.state.deliveryContacts.length === 0) {
            this.state.deliveryContacts = await DeliveryContact.all()
        }
    },

    async fetchRoutePlans() {
        if (this.state.deliveryContacts.length === 0) {
            this.state.routePlans = await RoutePlan.all();
        }
    },

    async fetchContacts() {
        if (this.state.contacts.length === 0) {
            this.state.contacts = await Contact.all();
        }
    },

}
